import { render, staticRenderFns } from "./ProductQuickEditSellPriceIncVat.vue?vue&type=template&id=33ce379f&scoped=true"
import script from "./ProductQuickEditSellPriceIncVat.vue?vue&type=script&lang=ts"
export * from "./ProductQuickEditSellPriceIncVat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce379f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ce379f')) {
      api.createRecord('33ce379f', component.options)
    } else {
      api.reload('33ce379f', component.options)
    }
    module.hot.accept("./ProductQuickEditSellPriceIncVat.vue?vue&type=template&id=33ce379f&scoped=true", function () {
      api.rerender('33ce379f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductQuickEditSellPriceIncVat.vue"
export default component.exports